/**
 * True when the app is running inside the native iOS/Android app shell rather
 * than a normal mobile browser tab.
 *
 * Used to hide Google Pay: Google Pay Web opens pay.google.com in a popup,
 * which an embedded WebView cannot host — it gets pushed out to the system
 * browser and the payment session dies. It works fine in a real browser.
 */
export function isNativeWebView() {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';

  // App wrappers commonly append their own token (Median/GoNative, Capacitor, Cordova)
  if (/median|gonative|capacitor|cordova/i.test(ua)) return true;

  // Android WebViews carry the "; wv" token
  if (/\bwv\b/.test(ua) && /Android/i.test(ua)) return true;

  // iOS WKWebView: iOS UA without the Safari token and not standalone-PWA Chrome/Firefox
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  if (isIOS && !/Safari/i.test(ua) && !/CriOS|FxiOS/i.test(ua)) return true;

  // Installed/standalone shells (iOS home-screen app)
  if (isIOS && window.navigator.standalone === true) return true;

  return false;
}